export const createRow = (desc, unit, qty, vatrate, type, origin) => {
    let price = priceRow(qty !== null && qty !== void 0 ? qty : 1, unit !== null && unit !== void 0 ? unit : 0);
    return {
        desc: desc,
        unit: unit !== null && unit !== void 0 ? unit : 0,
        qty: qty !== null && qty !== void 0 ? qty : 1,
        price: price,
        vatrate: vatrate,
        type: type,
        origin: origin
    };
};
export const subtotal = (items) => {
    return items.map(({ price }) => price).reduce((sum, i) => sum + i, 0);
};
export const moneyFormat = (num) => {
    return `€ ${num.toFixed(2).replace('.', ',')}`.replace(',00', ',-');
};
/**
 * How a picker shows what an object costs: "€ 30,-", or "vanaf € 30,-" when the price is not fixed.
 * Empty when there is no price to show. `ts` comes from `useI18N()`, see `Translate`.
 */
export const priceLabel = (row, { ts }) => {
    if (!row.price || row.price <= 0) {
        return '';
    }
    let price = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(row.price).replace(',00', ',-');
    return row.fixedPrice ? price : ts('vanaf %price%', { price: price });
};
export const durationFormat = (duration, { t, ts }) => {
    if (typeof duration === "number") {
        let h = Math.floor(duration / 60), _duration = ts('%duration% minuten', { duration: duration }, 'general');
        if (h > 0) {
            let m = duration - (h * 60), m1 = m < 10 ? 0 : '';
            if (m > 0) {
                _duration = ts('%hours% uur %minutes% minuten', { hours: h, minutes: `${m}${m1}` }, 'general');
            }
            else {
                _duration = ts('%hours% uur', { hours: h }, 'general');
            }
        }
        return _duration;
    }
    else {
        let parts = duration.split(' '), amount = parseInt(parts[0]), unit = parts[1], units = {
            day: t(amount === 1 ? 'dag' : 'dagen', 'general'),
            week: t(amount === 1 ? 'week' : 'weken', 'general'),
            month: t(amount === 1 ? 'maand' : 'maanden', 'general'),
            year: t(amount === 1 ? 'jaar' : 'jaar', 'general'),
        };
        //@ts-ignore
        return `${parts[0]} ${units[unit]}`;
    }
};
export const priceRow = (qty, unit) => {
    return qty * unit;
};
